export const ONBOARDING_BASE_PATH = '/members';
